import {Component} from '@angular/core';
import {Location} from '@angular/common';

@Component({
    selector: 'app-requirements',
    templateUrl: './requirements.component.html'
})
export class RequirementsComponent {
    constructor(private _location: Location) {
    }

    clickBack() {
        this._location.back();
    }
}



// WEBPACK FOOTER //
// /media/webdesign/5E0ECC7B0ECC4E29/www/leasytool/src/app/requirements/requirements.component.ts